var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",null,React.createElement("g",{"transform":"translate(-1149 -7586) translate(1149 7586)"},[React.createElement("circle",{"cx":"22","cy":"22","r":"21.5","stroke":"#FFF","key":0}),React.createElement("g",{"fill":"#FFF","fillRule":"nonzero","key":1},React.createElement("path",{"d":"M11.254 4.151h2.373V.176C13.217.122 11.809 0 10.169 0 6.747 0 4.403 2.07 4.403 5.874v3.501H.627v4.444h3.776V25h4.63V13.82h3.623l.576-4.444h-4.2V6.315c0-1.285.36-2.164 2.222-2.164z","transform":"translate(15 10)"}))]))));
}

FacebookInline.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
